/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";

const VerticalInputField = props => {
  const { input, label, placeholder, type, meta: { touched, error } } = props;
  const invalid = touched && error ? "invalid" : "";
  return (
    <div className="form-group">
      <label htmlFor={input.name}>{label}</label>
      <input
        {...input}
        type={type}
        placeholder={placeholder}
        className={`form-control ${invalid}`}
      />
    </div>
  );
};
VerticalInputField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.boolean,
    error: PropTypes.string
  }).isRequired
};

export default VerticalInputField;



// WEBPACK FOOTER //
// ./src/forms/fields/VerticalInputField.js